/**
 * Device operations service for managing device registration.
 *
 * This service provides async functions for device operations.
 * Uses direct API calls.
 */

import { fetchApi } from "common/utils/Api";

export type Device = {
  guid: string;
  name: string;
  enabled: boolean;
};

/**
 * Register a device with the backend.
 *
 * @param name - The device name
 * @param token - The push notification token
 */
export async function registerDevice(
  name: string,
  token: string
): Promise<Device> {
  const response = await fetchApi("devices", {
    method: "POST",
    body: JSON.stringify({ name, token }),
  });
  return response as Device;
}
